<div class="sign-up-container">
  <p class="text-center app-logo"><img src="{{ 'APP.LOGO' | translate }}" width="300" alt="logo"/></p>
  <p class="text-center sign-up-title" *ngIf="!errorMessage && !invitedCompany">{{'sign_up.title' | translate}}</p>
  <div class="company-info" *ngIf="!errorMessage && invitedCompany">
    <p class="d-flex flex-column align-items-center">
      <span>{{'register.general_info' | translate:{companyName: companyName} }}</span>
      <span class="account-info">{{'register.account_info' | translate:{accountId: accountId} }}</span>
    </p>
  </div>
  <p class="sign-up-error" *ngIf="errorMessage">
    <span class="error">{{errorMessage}}</span>
  </p>
  <form class="sign-up-form" novalidate (ngSubmit)="onSubmit(newUser)" [formGroup]="newUser">
    <input required formControlName="fullName"
           name="fullName"
           type="text"
           class="form-control"
           placeholder="{{'register.fields.full_name' | translate}}" />

    <input required
           formControlName="email"
           name="email"
           type="email"
           class="form-control"
           placeholder="{{'register.fields.email' | translate}}"
           email />

    <input required
           formControlName="password"
           name="password"
           type="password"
           class="form-control password-field"
           placeholder="{{'register.fields.password' | translate}}" />

    <input required
           formControlName="confirmPassword"
           name="confirmPassword"
           type="password"
           class="form-control confirm-password-field"
           placeholder="{{'register.fields.confirm_password' | translate}}" />

    <div class="term-service">
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input"
               type="checkbox"
               (change)="onUpdateTermAndServiceAgreement()"
               [formControlName]="'acceptTermService'"
               name="acceptTermService">
        <label class="custom-control-label">
          <span class="static-text">{{'register.fields.agreement' | translate}}</span>
          <a href="https://www.getachoo.com/terms-of-service" target="_blank" class="term-service-link">{{'register.fields.term_service' | translate}}</a>
        </label>
      </div>
    </div>
    <button class="btn btn-default"
            type="submit"
            [disabled]="newUser.invalid">{{'sign_up.btn' | translate}}</button>
    <p class="register-new-account-link d-flex flex-row" *ngIf="!invitedCompany">
      <span>{{'sign_up.click' | translate}}</span>
      <a [routerLink]="['/login']" class="register-link">{{'sign_up.here' | translate}}</a>
      <span>{{'sign_up.login_ready' | translate}}</span>
    </p>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/sign-up/sign-up-form/sign-up-form.component.html